export default function () {
  return {};
}



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxInput/Popup/defaultProps.js